import { render } from "./DesignRoom.vue?vue&type=template&id=3faa0f86&scoped=true"
import script from "./DesignRoom.vue?vue&type=script&lang=js"
export * from "./DesignRoom.vue?vue&type=script&lang=js"

import "./DesignRoom.vue?vue&type=style&index=0&id=3faa0f86&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3faa0f86"

export default script